/* eslint-disable max-lines-per-function */
import type { CSSProperties } from "react"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import {
  faCircleCheck,
  faCircleInfo,
  faTriangleExclamation,
  faCircleXmark,
  faSpinner,
} from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Toaster = (props: ToasterProps) => (
  <Sonner
    theme="light"
    className="toaster"
    closeButton
    toastOptions={{
      classNames: {
        icon: "self-start mt-1",
      },
    }}
    icons={{
      success: (
        <FontAwesomeIcon
          icon={faCircleCheck}
          className="block size-5 text-primary-green-500"
        />
      ),
      info: (
        <FontAwesomeIcon
          icon={faCircleInfo}
          className="block size-5 text-primary-blue-500"
        />
      ),
      warning: (
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className="block size-5 text-primary-orange-500"
        />
      ),
      error: (
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="block size-5 text-primary-red-400"
        />
      ),
      loading: (
        <FontAwesomeIcon
          icon={faSpinner}
          className="block size-5 animate-spin text-neutrals-500"
        />
      ),
    }}
    style={
      {
        "--normal-bg": "var(--color-neutrals-100)",
        "--normal-text": "var(--color-neutrals-900)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)",
        // Radix Dialog sets body { pointer-events: none } when open.
        // Explicitly override so toasts remain interactive inside a Sheet/Dialog.
        pointerEvents: "auto",
      } as CSSProperties
    }
    {...props}
  />
)

export { Toaster }
